<template>
  <nav
    class="navbar navbar-vertical fixed-left navbar-expand-md navbar-dark bg-white navbar-full-width"
    id="sidenav-main"
  >
    <div class="container-fluid">
      <!--Toggler-->
      <navbar-toggle-button @click.native="showSidebar">
        <span class="navbar-toggler-icon"></span>
      </navbar-toggle-button>
      <router-link class="navbar-brand" to="/">
        <img src="@/assets/app_logo.png" class="navbar-brand-img" alt="..." />
      </router-link>

      <slot name="mobile-right">
        <ul class="nav align-items-center d-md-none">
          <base-dropdown class="nav-item" position="right">
            <a slot="title" class="nav-link" href="#" role="button">
              <div class="media align-items-center">
                <span class="avatar avatar-sm rounded-circle">
                  <img
                    v-if="user"
                    alt="Image placeholder"
                    :src="user.profile ? user.profile : require('@/assets/default_profile_picture.png')"
                  />
                </span>
              </div>
            </a>

            <router-link to="/profile" class="dropdown-item">
              <i class="ni ni-single-02"></i>
              <span>My profile</span>
            </router-link>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" @click="onLogoutClicked()">
              <i class="ni ni-user-run"></i>
              <span>Logout</span>
            </a>
          </base-dropdown>
        </ul>
      </slot>
      <slot></slot>
      <div
        v-show="$sidebar.showSidebar"
        class="navbar-collapse collapse show sidebar-item-container"
        id="sidenav-collapse-main"
      >
        <div class="navbar-collapse-header d-md-none">
          <div class="row">
            <div class="col-6 collapse-brand">
              <router-link to="/">
                <img src="@/assets/app_logo.png" />
              </router-link>
            </div>
            <div class="col-6 collapse-close">
              <navbar-toggle-button @click.native="closeSidebar"></navbar-toggle-button>
            </div>
          </div>
        </div>

        <ul class="navbar-nav">
          <slot name="links"></slot>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import {
  RESET_AUTH_STATE,
  RESET_USER_STATE,
  RESET_LIVE_STREAM_STATE,
  RESET_COMMENT_STATE,
  RESET_NOTIFICATION_STATE,
  RESET_CLUB_STATE,
  RESET_SCHEDULE_STATE,
  LOGOUT
} from '@/store/actions.type'

import { mapGetters } from 'vuex'

import NavbarToggleButton from '@/components/NavbarToggleButton'

export default {
  name: 'sidebar',
  components: {
    NavbarToggleButton
  },
  props: {
    logo: {
      type: String,
      default: '@/assets/logo.png',
      description: 'Sidebar app logo'
    },
    autoClose: {
      type: Boolean,
      default: true,
      description:
        'Whether sidebar should autoclose on mobile when clicking an item'
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    }
  },
  methods: {
    closeSidebar() {
      this.$sidebar.displaySidebar(false)
    },
    showSidebar() {
      this.$sidebar.displaySidebar(true)
    },
    onLogoutClicked() {
      Promise.all([
        this.$store.dispatch(RESET_AUTH_STATE),
        this.$store.dispatch(RESET_USER_STATE),
        this.$store.dispatch(RESET_LIVE_STREAM_STATE),
        this.$store.dispatch(RESET_COMMENT_STATE),
        this.$store.dispatch(RESET_NOTIFICATION_STATE),
        this.$store.dispatch(RESET_CLUB_STATE),
        this.$store.dispatch(RESET_SCHEDULE_STATE),
        this.$store.dispatch(LOGOUT)
      ]).then(() => {
        this.$router.push({ name: 'login' })
      })
    }
  },
  computed: {
    ...mapGetters({
      user: 'currentUser'
    })
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false
    }
  }
}
</script>
<style>
.avatar {
  background-color: transparent !important;
}
.navbar-full-width {
  padding-left: 0 !important;
  padding-right: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.sidebar-item-container {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.navbar-brand {
  background-color: #962100 !important;
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
  box-shadow: 0 6px 10px 0 rgba(160, 90, 0, 0.1),
    0 6px 20px 0 rgba(160, 90, 0, 0.19);
}

@media (max-width: 767.98px) {
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid {
    padding-right: 0;
    padding-left: 0;
    background-color: #962100 !important;
  }
  .navbar-nav .nav-link {
    padding: 0.625rem 0;
    color: rgba(0, 0, 0, 0.5) !important;
  }
  .navbar {
    padding: 0 0 !important;
  }
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-dark .navbar-nav .nav-link:hover {
  color: #962100 !important;
}
.router-link-active {
  color: #962100 !important;
}

.navbar-vertical .navbar-brand-img,
.navbar-vertical .navbar-brand > img {
  max-width: 100%;
  max-height: 4rem;
}

@media (min-width: 768px) {
  .navbar-vertical.navbar-expand-md .navbar-brand-img {
    max-height: 5rem;
  }
}
</style>
